import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import UnifiedComputeResource from '../UnifiedCompute.resource';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'getCompute';
const CLEAR_GET_COMPUTE_STATE = `${prefix}/CLEAR_STATE`;
export const clearGetComputeState = () => {
    return {
        type: CLEAR_GET_COMPUTE_STATE,
        payload: {},
    };
};
const getComputeArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        return UnifiedComputeResource.getCompute(inputPayload.workspaceId, inputPayload.id);
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const getComputeEpicReducer = loadResourcesUtils(getComputeArgs);
// Reducer
export const getComputeReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_GET_COMPUTE_STATE:
            return defaultReducerState;
        default:
            return getComputeEpicReducer.reduxChange(state, action);
    }
    return state;
};
export default getComputeReducer;

//# sourceMappingURL=GetCompute.ducks.js.map
